import React, { useEffect, useState } from "react";
import { useParams, Link, useNavigate } from "react-router-dom";

function Gallery() {
  const { id } = useParams();
  const navigate = useNavigate();

  const [photos, setPhotos] = useState([]);
  const [page, setPage] = useState(0);
  const [total, setTotal] = useState(-1);
  const [loadding, setLoadding] = useState(false);

  useEffect(() => {
    console.log('VERSION 0.1.3');
    fetchPhotos();
  }, [id]);

  const fetchPhotos = async () => {
    setLoadding(true);
    const response = await fetch(`https://api.suko.space/api/images/list/${id}?page=${page+1}`);
    // const response = await fetch(
    //   `http://192.168.1.62:4000/api/images/list/${id}?page=${page+1}`
    // );
    const data = await response.json();
    console.log(data);
    setPhotos([...photos, ...data.images]);
    setTotal(data.totalPages);
    setPage(data.currentPage);
    setLoadding(false);
  };

  return (
    <div
      style={{
        paddingTop: "20px",
        paddingBottom: "70px",
        backgroundColor: "#efefef",
        flex: "1 1",
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          flexWrap: "wrap",
          gap: "1rem",
        }}
      >
        {photos.length > 0
          ? photos.map((photo) => (
              <img
                key={photo._id}
                src={`https://tvcologan.com/suko_photocall/images/${id}/small/${photo.filename}`}
                alt={photo.name}
                style={{
                  width: "45vw",
                  height: "45vw",
                  marginLeft: "2vw",
                  objectFit: "cover",
                  borderRadius: "10px",
                }}
              />
            ))
          : null}
      </div>
      {photos.length > 0 && photos.length % 10 === 0 && page < total ? (
        <div className="loadMoreImg">
          {loadding ? <div>Cargando...</div> : <div onClick={fetchPhotos}>Cargar más fotos</div>}
        </div>
      ) : null}
      <div style={{ height: "30px" }}></div>
      <div
        style={{
          display: "flex",
          gap: "1rem",
          bottom: "15px",
          left: "15px",
          position: "fixed",
          width: "70%",
          backgroundColor: "#9EC6F3",
          borderTop: "1px solid #e0e0e0",
          borderRadius: "30px",
        }}
      >
        <div
          style={{
            textAlign: "center",
            width: "100%",
            cursor: "pointer",
            height: "50px",
          }}
          onClick={() => navigate(`/gallery/${id}/upload`)}
        >
          <Link
            to={`/gallery/${id}/upload`}
            style={{
              color: "black",
              height: "100%",
              justifyContent: "center",
              alignItems: "center",
              display: "flex",
              fontWeight: "bold",
              textDecoration: "none",
            }}
          >
            Subir fotos
          </Link>
        </div>
      </div>
    </div>
  );
}

export default Gallery;
